import { Component, inject, Input } from '@angular/core'
import HttpError, { FormErrors } from '@ui/HttpError'
import {
	FormValidationComponent,
	ValidationMessages,
} from '@ui/Components/Form/FormValidation.Component'
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { PermissionsService } from '@client/Services/PermissionsService'
import {
	InputValue,
	TextInputComponent,
} from '@ui/Components/Form/TextInput/TextInput.Component'
import { FlatButtonComponent } from '@ui/Components/Form/Button/FlatButton.Component'
import { TwoFactorError } from '@client/Errors/TwoFactorError'

@Component({
	selector: 'login-form',
	templateUrl: './LoginForm.Component.html',
	imports: [
		FormsModule,
		ReactiveFormsModule,
		TextInputComponent,
		FlatButtonComponent,
	],
})
export class LoginFormComponent extends FormValidationComponent {
	@Input() private readonly loginSuccessful: () => void | Promise<void>

	@Input() private readonly showChallenge: () => void | Promise<void>

	public formErrors: FormErrors = {
		email: '',
		password: '',
	}

	protected validationMessages: ValidationMessages = {
		email: {
			required: 'Email is required',
		},
		password: {
			required: 'Password is required',
		},
	}

	private readonly permissionsService: PermissionsService

	constructor() {
		super()
		this.permissionsService = inject(PermissionsService)
	}

	public login = async (
		email: InputValue,
		password: InputValue,
	): Promise<void> => {
		this.validateForm()

		if (this.form.valid) {
			try {
				await this.permissionsService.login(email as string, password as string)

				this.loginSuccessful()
			} catch (error) {
				if (error instanceof TwoFactorError) {
					this.showChallenge()
					return
				}

				if (error instanceof HttpError) {
					if (error.getStatus() === 419) {
						window.location.reload()

						return
					}

					this.formErrors = error.handleFormErrors(this.formErrors, '')
					this.markInvalidFields()
				} else {
					throw error
				}
			}
		}
	}

	protected buildForm = (): void => {
		this.form = this.formBuilder.group({
			email: ['', [Validators.required]],
			password: ['', [Validators.required]],
		})
	}
}
